<script src="//unpkg.com/v-viewer/dist/v-viewer.js"></script>
<template>
  <div>
    <h1 class="page-title text-center">Update Ticket</h1>

    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row>
          <!--       <b-col lg="6" sm="12">
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Resolved
                <span class="text-danger">*</span>
              </template>

              <multiselect
                id="input-status"
                placeholder="Select status"
                v-model="resolved"
                :options="['True', 'False']"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              ></multiselect>
            </b-form-group>
          </b-col>-->
          <b-col>
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Current Status
                <span class="text-danger">*</span>
              </template>

              <multiselect
                id="input-status"
                placeholder="Select status"
                v-model="currentStatus"
                :options="['OPEN', 'IN PROGRESS', 'RESOLVED', 'CANCEL']"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              ></multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            Tentitive Date
            <b-form data-v-step="1">
              <b-input-group class="box-shadow2">
                <b-input-group-append>
                  <b-form-datepicker
                    sm
                    button-only
                    id="start-datepicker"
                    placeholder="Start Date"
                    :min="minDate"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    v-model="startDateValue"
                  >
                  </b-form-datepicker>
                </b-input-group-append>
                <b-form-input
                  id="example-input"
                  v-model="startDateValue"
                  type="text"
                  placeholder="Tentitive Date"
                  autocomplete="off"
                  :class="{
                    '': !isDarkMode,
                    'bg-dark text-light': isDarkMode
                  }"
                  disabled
                ></b-form-input>
              </b-input-group> </b-form
          ></b-col>
        </b-row>
        <b-row>
          <b-col lg="6" sm="12">
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Complaint Source
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                id="input-complaint-source"
                type="text"
                v-model="complaintSource"
                disabled
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                placeholder="Enter complaint source"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Issue Severity
                <span class="text-danger">*</span>
              </template>

              <multiselect
                id="input-status"
                placeholder="Select Priority"
                v-model="priority"
                disabled
                :options="['LOW', 'MEDIUM', 'HIGH']"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              ></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col lg="6" sm="12">
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Estimated Time
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                id="input-escalation-time"
                type="text"
                v-model="escalationTime"
                placeholder="Enter estimated time"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col lg="6" sm="12">
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Details
                <span class="text-danger">*</span>
              </template>

              <b-form-textarea
                id="input-issue"
                type="text"
                v-model="details"
                disabled
                required
                placeholder="Enter issue"
                :class="{
                  'box-shadow3': !isDarkMode,
                  'placeholder-light text-light bg-dark box-shadow3': isDarkMode
                }"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col lg="6" sm="12" v-if="cancelRequired">
            <b-form-group id="group-name" label-for="input-name">
              <template v-slot:label>
                Provide Reason
                <span class="text-danger">*</span>
              </template>

              <b-form-textarea
                id="input-name"
                type="text"
                v-model="cancelReason"
                ref="cancelReasonField"
                placeholder="Enter Description If Any"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
              />

              <b-form-invalid-feedback ref="invalidFeedback" style="display: none" id="input-name-invalid">
                **Cancelation Reason is Required**
              </b-form-invalid-feedback>
            </b-form-group></b-col
          >
        </b-row>
        <b-row>
          <b-col v-if="resolvedImageUrl === ''">
            <b-form-group id="input-group-5" label-for="input-5">
              <template v-slot:label>
                Upload File
                <span class="text-danger">*</span>
              </template>
              <input type="file" @change="uploadFile($event)" accept="image/*" />
              <!-- <b-form-file id="input-5" v-model="file" required placeholder="Upload file"></b-form-file> -->
            </b-form-group>
          </b-col>
          <b-col v-else class="margin:5px;">
            Uploaded Image
            <div class="width-200px" v-if="resolvedImageUrl !== ''">
              <template>
                <div v-viewer>
                  <template>
                    <div :key="resolvedImageUrl" class="imageView">
                      <img :src="resolvedImageUrl" class="dynamic-image" thunbnail fluid alt="No Image Available" />
                    </div>
                  </template>
                  <link href="//unpkg.com/viewerjs/dist/viewer.css" rel="stylesheet" />
                </div>
              </template>
            </div>
          </b-col>
        </b-row>

        <b-form-group>
          <b-row class="mt-2">
            <b-col class="text-right">
              <b-button
                type="submit"
                v-if="!this.ticket.isResolved && this.ticket.currentStatus !== 'CANCEL'"
                size="sm"
                :variant="isDarkMode ? 'outline-success' : 'success'"
                :disabled="loading"
              >
                <span class="spinner spinner-white" v-if="loading"></span>
                <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
              </b-button>
              <b-button
                class="ml-2"
                size="sm"
                :variant="isDarkMode ? 'outline-warning' : 'warning'"
                :to="{ path: `/complain` }"
              >
                <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import VueViewer from 'v-viewer';
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import moment from 'moment';

Vue.use(VueViewer);

export default {
  name: 'ModifyTicket',
  components: {
    Multiselect
  },
  data() {
    return {
      file: [],
      resolvedImageUrl: '',
      startDateValue: null,
      cancelReason: '',
      cancelRequired: false,
      minDate: moment().format('YYYY-MM-DD'),
      formLoaded: true,
      loading: false,
      currentStatus: '',
      details: '',
      resolved: '',
      complaintSource: '',
      priority: '',
      escalationTime: '',
      closingImage: ''
    };
  },
  mounted() {
    this.getOne({ id: this.$route.params.id });
  },
  computed: {
    ...mapState('contactUs', ['ticket']),
    ...mapState('darkMode', ['isDarkMode'])
  },
  methods: {
    ...mapActions('contactUs', ['getOne', 'patchOne', 'uploadImage']),
    uploadFile(event) {
      const [file] = event.target.files;
      this.file = file;
      this.uploadImage({ file });
    },

    onSubmit() {
      if (this.cancelRequired) {
        const trimmedReason = this.cancelReason?.trim();

        if (!trimmedReason || trimmedReason.length < 2) {
          // Show validation message
          if (this.$refs.invalidFeedback) {
            this.$refs.invalidFeedback.style.display = 'block';
          }
          if (this.$refs.cancelReasonField) {
            this.$refs.cancelReasonField.focus();
          }
          return;
        }
      }

      // Build the ticket object and proceed to patch
      const ticket = {
        name: this.ticket.name,
        mobile: this.ticket.mobile,
        email: this.ticket.email,
        issue: this.ticket.issue,
        details: this.ticket.details,
        storeid: this.ticket.storeid,
        complainNumber: this.ticket.complainNumber,
        imageUrl: this.ticket.imageUrl,
        complainSource: this.ticket.complainSource,
        currentStatus: this.currentStatus,
        isResolved: this.resolved === 'True',
        issuePriority: this.priority,
        closingImage: this.closingImage.name,
        reslovedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
        escalationTime: this.escalationTime,
        department: this.ticket.department,
        subDepartment: this.ticket.department,
        tentativeDate: this.startDateValue ? moment(this.startDateValue).format('YYYY-MM-DD HH:mm:ss') : null,
        resolvedImageName: this.file.name ? this.file.name : '',
        cancelReason: this.cancelReason || ''
      };

      this.patchOne({ id: this.$route.params.id, ticket });
      this.$router.push('/complain');
    }
  },
  watch: {
    currentStatus(newValue) {
      if (newValue && newValue === 'CANCEL') {
        this.cancelRequired = true;
      } else {
        this.cancelRequired = false;
      }
      if (newValue && newValue === 'RESOLVED') {
        this.resolved = 'True';
      } else {
        this.resolved = 'False';
      }
    },
    ticket(newV) {
      if (newV) {
        this.currentStatus = newV.currentStatus;
        this.resolved = newV.isResolved === true ? 'True' : 'False';
        this.complaintSource = newV.complainSource;
        this.cancelReason = newV.cancelReason;
        this.details = newV.details;
        this.priority = newV.issuePriority;
        this.resolvedImageUrl = newV.resolvedImageUrl;
        this.escalationTime = newV.escalationTime;
        this.startDateValue = newV.tentativeDate ? moment(newV.tentativeDate).format('YYYY-MM-DD') : null;
      }
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.question-text {
  font-size: 1.2rem;
  font-weight: bold;
}

.width-200px {
  width: 100px;
  height: 80px;
  overflow: hidden;
}

.imageView {
  display: inline-flex;
  margin: 2px;
}
.dynamic-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* or 'cover' if you prefer to fill the box */
  cursor: pointer;
}
</style>
